import { get, isEmpty } from 'lodash';

import { offsetTop, animateScrollTop } from '@cian/ui/app/services/dom-utils.jsm';

import app from '../app';

app.factory('remoteValidationService', [
  '$rootScope', '$log', '$timeout', 'popupService', 'addFormService',
  ($rootScope, $log, $timeout, popupService, addFormService) =>
{
  const defaultFieldMessage = 'Проверьте правильность заполнения поля';
  const defaultFormMessage = 'Проверьте правильность заполнения формы';

  const fieldMapping = {
    flatType: 'roomsCount',
    'geo.address': 'geo.userInput',
    'geo.jk.name': 'geo.jk',
    'geo.jk.id': 'geo.jk',
  };
  const premoderationFields = [
    'cottageVillageName',
  ];

  const premoderationFieldMapping = {
    'kp.id': 'cottageVillageName',
  };

  class RemoteValidator {
    /*eslint-disable */
    validationMessages = {
      format: 'Введите корректное значение',
      required: 'Введите значение',
      invalid: 'Введите корректное значение',
      validator_failed: 'Введите корректное значение',
      null: 'Введите значение',
      type: 'Введите корректное значение',
      special: 'Введите корректное значение',
      invalid_guid: 'Неправильный идентификатор',
      wrongValue: 'Введите корректное значение',
      notANumber: 'Неверный номер',
      invalidPassword: 'Неверный пароль',
      invalidForRegion: 'Номер телефона не соответствует региону',
      invalidSMSCode: 'Неверный код',
      EmailAlreadyExists: 'Пользователь с таким e-mail уже зарегистрирован. Попробуйте войти.',
      announcement_with_no_phones: 'Не указан ни один номер телефона для объявления.',
      outOfRange: 'Введите корректное значение',
      // преобразованные коды для телефонов
      // countryCode
      invalidCountryCode: 'Номер указан неверно. Введите номер согласно заданному формату',
      outOfRangeCountryCode: 'Номер указан неверно. Введите номер согласно заданному формату', // Введите корректное значение // Если пустая строка
      // number
      notANumberNumber: 'Номер указан неверно. Введите номер согласно заданному формату', // Неверный номер
      tooShortAfterIddNumber: 'Номер указан неверно. Введите номер согласно заданному формату',
      tooShortNumber: 'Номер указан неверно. Введите номер согласно заданному формату',
      tooLongNumber: 'Номер указан неверно. Введите номер согласно заданному формату',
      outOfRangeNumber: 'Номер указан неверно. Введите номер согласно заданному формату', // Введите корректное значение // Если пустая строка
      // _schema
      invalidForRegion_schema: 'Номер указан неверно. Введите номер согласно заданному формату', // Номер телефона не соответствует региону
      // Заблокированный телефон
      blocked_phone_number: 'Указанный телефонный номер запрещен к использованию',
      // Два одинаковых телефона
      duplicatePhone: 'Вы уже ввели этот номер телефона. Укажите другой номер.',
      invalid_verification_code: 'Неверный код подтверждения.',
      notMobilePhone: 'Укажите номер мобильного телефона'
    };
    /*eslint-enable */

    // Связанные поля (изменение любого поля приводит к удалению валидации связанных полей)
    linkedFields = [
      ['totalArea', 'livingArea', 'kitchenArea'],
      ['floorNumber', 'floorsCount'],
    ];

    form;

    // Набор триггеров по полям (соответсвие измененное поле->массив полей на удаление валидации)
    triggers = {
      fields: {},
      sections: {},
      form: {},
      listeners: {},
    };

    // Набор сообщений об ошибках
    messages = {
      fields: {},
      sections: {},
      form: {},
    };

    constructor(form) {
      this.form = form;
    }

    // Маппинг тригеров для связанных полей
    mapTriggers(fieldName) {
      let triggers;
      triggers = [fieldName];
      if (this.linkedFields && this.linkedFields.length > 0) {
        angular.forEach(this.linkedFields, linked => {
          if (linked.indexOf(fieldName) !== -1) {
            angular.forEach(linked, field => {
              if (triggers.indexOf(field) === -1) {
                triggers.push(field);
              }
            });
          }
        });
      }
      return triggers;
    }

    // Маппинг серверного ответа в объект валидации поле->{триггеры, сообщения}
    map(data) {
      const result = {
        fields: {},
        form: {},
        sections: {},
      };
      if (data.errors) {
        angular.forEach(data.errors, (value, key) => {
          if (fieldMapping[key]) key = fieldMapping[key];
          result.fields[key] = {
            triggers: this.mapTriggers(key),
            messages: value,
          };
        });
      }
      return result;
    }

    // Получение текста серверной ошибки для поля
    getErrorFieldMessage(fieldName) {
      return this.messages.fields[fieldName] || [];
    }

    // Получение текста серверной ошибки по коду ошибки
    getErrorMessage(errorCode, messageObj = {}) {
      let message;
      if ((errorCode === null || errorCode === 'message') && messageObj.message) { // Принимаем текст сообщения от сервера
        message = messageObj.message;
      }
      else if (this.validationMessages[errorCode]) {
        message = this.validationMessages[errorCode];
      }
      else if (messageObj.message) {
        message = messageObj.message;
      }
      else {
        const errorText = 'Серверная валидация: нет ' + (errorCode ? 'расшифровки кода ' + errorCode : 'сообщения валидации');
        if (window.Raven) {
          window.Raven.captureMessage(errorText, {
            level: 'error',
            extra: { messageObj }
          });
        }
        $log.warn(errorText, messageObj);
      }
      return message;
    }

    // Поиск имени по имени поля либо модели
    getFieldName(fieldName) {
      let name = null;
      if (this.form[fieldName]) {
        name = fieldName;
      } else {
        const element = document.body.querySelector('[ng-model*="ad.' + fieldName + '"]') || document.body.querySelector('[name="' + fieldName + '"]');
        if (element) {
          const elementName = element.getAttribute('name') || null;
          if (elementName && (this.form[elementName] || angular.element(element).data('$ngModelController'))) {
            name = elementName;
          }
        }
      }
      return name;
    }

    getFieldPlanB(fieldName) {
      const element = document.body.querySelector('[name="' + fieldName + '"]');
      if (element) {
        return angular.element(element).data('$ngModelController');
      }
      return null;
    }

    getElementByField(fieldName) {
      const element = document.body.querySelector('[name="' + fieldName + '"]');
      return element;
    }

    // Получение поля формы по его имени,
    getField(fieldName) {
      return this.form[this.getFieldName(fieldName)] || this.getFieldPlanB(fieldName) || null;
    }

    // Добавление триггеров для поля
    addFieldsTrigger(trigger, fieldName) {
      const field = this.getField(trigger);
      if (field) {
        if (!this.triggers.fields[trigger]) {
          field.$viewChangeListeners.push(this.triggers.listeners[trigger] = () => {
            this.removeTriggeredFields(trigger);
          });
          this.triggers.fields[trigger] = [];
        }
        if (this.triggers.fields[trigger].indexOf(fieldName) === -1) {
          this.triggers.fields[trigger].push(fieldName);
        }
      }
    }

    // Считать поля триггера валидными + удаление триггера и listener
    removeTriggeredFields(trigger) {
      const triggerField = this.getField(trigger);
      const triggered = this.triggers.fields[trigger];
      if (triggered) {
        angular.forEach(triggered, fieldName => {
          const field = this.getField(fieldName);
          if (field) {
            this.removeFieldError(fieldName);
          }
        }, this);
        delete this.triggers.fields[trigger];
        if (this.triggers.listeners[trigger]) {
          if (triggerField) {
            triggerField.$viewChangeListeners.splice(
              triggerField.$viewChangeListeners.indexOf(this.triggers.listeners[trigger]), 1);
          }
          delete this.triggers.listeners[trigger];
        }
      }
    }

    // Установить валидацию для поля в невалидно, иницилизировать триггеры, подготовить сообщения об ошибках
    setFieldError(fieldName, messages, triggerFieldNames, errorMessageOriginal) {
      const field = this.getField(premoderationFieldMapping[fieldName] || fieldName);
      let mes = [];

      switch (true) {
        case (fieldName === 'password'):
          mes.push(errorMessageOriginal);
        break;

        case (fieldName.indexOf('videos') === 0):
          $rootScope.$emit('youtube.invalid', messages[0]);

          return;

        case (Array.isArray(messages)):
          mes = messages.map((message) => this.getErrorMessage(message.code, message)).filter(Boolean);
        break;

        default:
          mes.push(this.getErrorMessage(messages.code, messages));
      }

      if (field) {
        const isPremoderationField = premoderationFields.includes(field.$name);
        const names = isPremoderationField ? field.$name : triggerFieldNames;

        if (Object.keys(field.$validators).length > 0 || isPremoderationField) {
          this.messages.fields[field.$name] = mes || defaultFieldMessage;

          if (Array.isArray(names)) {
            angular.forEach(names, triggerFieldName => {
              this.addFieldsTrigger(this.getFieldName(triggerFieldName), field.$name);
            }, this);
          } else {
            this.addFieldsTrigger(this.getFieldName(names), field.$name);
          }

          field.$dirty = true;
          field.$setValidity('remote', false);
        } else {
          popupService.openPopup('validationError', {
            errorName: null,
            errorMessage: mes || defaultFormMessage
          });
          if (window.Raven) {
            window.Raven.captureException(new Error('Серверная валидация: поле ' + fieldName + ' не имеет локальной валидации'), {
              level: 'error',
              extra: {
                fieldName: fieldName
              }
            });
          }
          $log.error('Серверная валидация: поле ' + fieldName + ' не имеет локальной валидации');
        }
      } else {
        popupService.openPopup('validationError', {
          errorName: null,
          errorMessage: mes || defaultFormMessage
        });
        if (window.Raven) {
          window.Raven.captureException(new Error('Серверная валидация: поле ' + fieldName + ' не найдено'), {
            level: 'error',
            extra: {
              fieldName: fieldName
            }
          });
        }
        $log.error('Серверная валидация: поле ' + fieldName + ' не найдено');
      }
    }

    // Считать поле валидным, удалить сообщение об ошибке
    removeFieldError(fieldName) {
      const field = this.getField(fieldName);
      if (field) {
        field.$setValidity('remote', true);
        if (this.messages.fields[field.$name]) {
          delete this.messages.fields[field.$name];
        }
      }
    }

    // Удаляет все remote-ошибки с полей
    removeFieldErrors() {
      if (!this.triggers.fields) {
        return;
      }

      Object.values(this.triggers.fields).forEach((field) => {
        this.removeFieldError(field);
      });
    }

    getAllScrollableErrors($error) {
      return Object.keys($error)
        .map(key => {
          if (Array.isArray($error[key])) {
            return {
              key,
              fieldName: $error[key][0].$name,
            };
          }

          return undefined;
        })
        .filter(Boolean);
    }

    scrollToFirstError(form, errors) {
      $timeout(() => {
        let firstErrorElement = document.body.querySelector('.cui-invalid');
        let scrollableFieldName;

        // Для Залога собственнику не срабатывает установка классов
        // TODO: техдолг - нужно починить в залоге собственника cian/static/addform/app/scripts/segment-inputs-config/price-and-deal-terms/deposit/deposit.js
        // проверку на обязательность поля
        try {
          const scrollableErrors = this.getAllScrollableErrors(form.$error);

          scrollableErrors.forEach(({ fieldName }) => {
            if (firstErrorElement) {
              return;
            }

            firstErrorElement =
              document.body.querySelector('[name="' + fieldName + '"]') ||
              document.body.querySelector('[input-name="' + fieldName + '"]');

            if (firstErrorElement) {
              scrollableFieldName = fieldName;
            }
          });
        } catch (e) {}

        if (firstErrorElement) {
          // Телефоны используют свою форму, поэтому для отображения валидации нужно принудительно убрать фокус
          // Ошибка сразу не отобразится из-за дайджест-цикла, поэтому нужно еще принудительно вызвать $apply()
          if (scrollableFieldName === 'phones.0' || scrollableFieldName === 'phones.1') {
            try {
              form[scrollableFieldName].$focus = false;
              $rootScope.$apply();
            } catch (e) {}
          }

          animateScrollTop({
            to: Math.max(offsetTop(firstErrorElement) - 50, document.body.scrollHeight - document.body.clientHeight),
            duration: 500,
            done: () => {},
          });
        } else {
          let serializedErrors = '';

          try {
            serializedErrors = errors ? JSON.stringify(errors) : 'no errors sent';
          } catch (e) {
            serializedErrors = 'parse errors failed';
          }

          // В большинстве случаев в serializedErrors будет короткая строка с одним невалидным полем,
          // поэтому отправляем в логах и не опасаемся, что логи раздуются
          throw new Error(
            `Поля с ошибками не найдены, form.$error: ${angular.toJson(form.$error)}, errors: ${serializedErrors}`
          );
        }
      }, 2000);
    }

    // Установить валидаторы по серверной ошибке
    setValidators(data) {
      const errors = this.map(data);

      angular.forEach(errors.fields, function (value, key) {
        this.setFieldError(
          key,
          value.messages,
          value.triggers,
          data.message,
        );
      }, this);

      const errorsObj = get(data, 'errors', {});
      const errorFields = Object.keys(errorsObj);

      if (!isEmpty(errorFields)) {
        this.scrollToFirstError(this.form, data);
      }
    }
  }

  return {
    // Получение экземпляра серверного валидатора для формы
    getInstance: form => {
      return new RemoteValidator(form);
    },
  };
}]);
